
class showI9DocsCrtl {
  /* @ngInject */
  constructor (worker, UsersService, $mdDialog, $mdToast, $rootScope, $window) {
    this.worker = worker
    this.UsersService = UsersService
    this.$window = $window
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$rootScope = $rootScope
    this.idImages = []
    this.getI9Docs()
  }

  getI9Docs () {
    this.loader = true
    this.UsersService.retrieveI9Documents(this.worker.id)
      .then((documents) => {
        this.idImages = documents
        this.loader = false
      })
      .catch(this.loader = false)
  }

  cancel () {
    this.$mdDialog.cancel()
  }

}

export default showI9DocsCrtl
